<template>
    <div class="wa-status">
        <SOSlotBase :bg-grey="true" :loading="!formReady">
            <template v-slot:title-bar>
                <SOTitleBar :type="'back'" :page-title="'Detail Status WA'" @back="back" />
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content v-if="formReady">
                <div>
                    <div class="detail-status">
                        <div class="containt d-flex m-d-12">
                            <div class="d-flex-between-center left" style="background: black; justify-content: center;">
                                <img
                                    v-if="isImage(statusTiny.type_media)"
                                    :src="`${imageStore}${statusTiny.media_name}`"
                                />
                                <label v-if="isText(statusTiny.type_media)" class="m-d-0 f-12 f-regular f-c-white">
                                    Caption
                                </label>
                                <img
                                    v-if="isVideo(statusTiny.type_media)"
                                    :src="`${imageStore}${statusTiny.thumb_name}`"
                                />
                            </div>
                            <div class="right">
                                <div class="d-flex-between-center m-d-8">
                                    <p class="m-d-0 f-14 f-regular f-c-black">{{ statusTiny.caption }}</p>
                                    <div style="width: 20px; min-width: 20px" @click="gotoEdit">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="19"
                                            viewBox="0 0 20 19"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M16.6666 1.89909C16.4188 1.89909 16.1811 1.99754 16.0058 2.17278L8.25239 9.92623L7.81189 11.6882L9.57388 11.2477L17.3273 3.49427C17.5026 3.31903 17.601 3.08135 17.601 2.83352C17.601 2.5857 17.5026 2.34802 17.3273 2.17278C17.1521 1.99754 16.9144 1.89909 16.6666 1.89909ZM14.8273 0.994267C15.3151 0.506466 15.9767 0.232422 16.6666 0.232422C17.3564 0.232422 18.018 0.506466 18.5058 0.994267C18.9936 1.48207 19.2677 2.14367 19.2677 2.83352C19.2677 3.52338 18.9936 4.18498 18.5058 4.67278L10.5892 12.5894C10.4824 12.6962 10.3486 12.772 10.202 12.8086L6.8687 13.642C6.58472 13.713 6.28431 13.6298 6.07733 13.4228C5.87035 13.2158 5.78714 12.9154 5.85813 12.6314L6.69147 9.29808C6.7281 9.15155 6.80386 9.01773 6.91066 8.91093L14.8273 0.994267ZM1.56548 2.73246C2.03433 2.26362 2.67021 2.00023 3.33325 2.00023H9.16658C9.62682 2.00023 9.99992 2.37332 9.99992 2.83356C9.99992 3.2938 9.62682 3.66689 9.16658 3.66689H3.33325C3.11224 3.66689 2.90028 3.75469 2.744 3.91097C2.58772 4.06725 2.49992 4.27921 2.49992 4.50023V16.1669C2.49992 16.3879 2.58772 16.5999 2.744 16.7562C2.90028 16.9124 3.11224 17.0002 3.33325 17.0002H14.9999C15.2209 17.0002 15.4329 16.9124 15.5892 16.7562C15.7455 16.5999 15.8332 16.3879 15.8332 16.1669V10.3336C15.8332 9.87332 16.2063 9.50023 16.6666 9.50023C17.1268 9.50023 17.4999 9.87332 17.4999 10.3336V16.1669C17.4999 16.8299 17.2365 17.4658 16.7677 17.9347C16.2988 18.4035 15.663 18.6669 14.9999 18.6669H3.33325C2.67021 18.6669 2.03433 18.4035 1.56548 17.9347C1.09664 17.4658 0.833252 16.8299 0.833252 16.1669V4.50023C0.833252 3.83719 1.09664 3.2013 1.56548 2.73246Z"
                                                fill="#206CFF"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="containt d-flex-between-center m-d-8" style="padding: 11px 12px;">
                            <div>
                                <p class="m-d-0 f-bold f-13 f-c-black">Ulangi setiap:</p>
                                <p class="m-d-0 f-regular f-13 f-c-black">
                                    {{ statusTiny.hari }} — {{ statusTiny.jam }}
                                </p>
                            </div>
                            <div style="text-align: center;">
                                <div>
                                    <SOInputOnOff
                                        ref="switchEnable"
                                        :checkboxes="checkAktifStatus"
                                        :disabled="isFetching"
                                        @selected="
                                            (e) => {
                                                toogleOnOff(e);
                                            }
                                        "
                                        :checked="isDisabled ? false : true"
                                    />
                                </div>
                                <div class="ph-item" style="padding: 0px; margin: 0px;" v-if="isFetching">
                                    <div class="ph-col-12" style="padding: 0px">
                                        <div class="ph-row m-d-0">
                                            <div class="ph-col-12 big m-d-0" style="height: 17px"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p class="m-d-0 f-c-blue f-12 f-semi" v-if="!isDisabled">Aktif</p>
                                    <p class="m-d-0 f-c-midgrey f-12 f-semi" v-else>Tidak aktif</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-x-20 m-t-16">
                        <label class="m-d-16 f-c-midgrey f-16 f-regular" v-if="!isDisabled">Aktivitas status ini</label>
                        <label class="m-d-16 f-c-midgrey f-16 f-regular" v-else>Riwayat postingan status ini</label>
                        <div>
                            <CardAktivitas
                                :data-list="aktivitas"
                                :data-count="aktivitasTotal"
                                :iddevice="getQuery.iddevice"
                                :id-status="getQuery.idStatus"
                            />
                        </div>
                    </div>
                    <SOLoadMoreLoading :id="'load-more-aktivitas'" :loading="isLoadMore" />
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

import CardAktivitas from "../components/CardAktivitas.vue";

import { moduleName } from "../store/state";

const aktifStatus = () => ({
    name: "status-wa",
    data: [
        {
            id: "status-wa",
            value: "1",
            title: ``,
            checked: false,
            titleBold: false,
        },
    ],
});

export default {
    name: "WaStatusDetail",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOInputOnOff,
        SOLoadMoreLoading,
        CardAktivitas,
    },
    data() {
        return {
            checkAktifStatus: aktifStatus(),
            backTo: "wa_status.list",
            param: {},
            formReady: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (!vm.getQuery.idStatus) {
                vm.back();
            }
        });
    },
    mounted() {
        this.init();
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormready(true);
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            aktivitas: "aktivitas",
            aktivitasTotal: "aktivitasTotal",
            dataDeviceTiny: "dataDeviceTiny",
            response: "response",
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            statusTiny: "statusTiny",
            imageStore: "imageStore",
            isVideo: "isVideo",
            isImage: "isImage",
            isText: "isText",
        }),
        getQuery() {
            return this.$route.query;
        },
        isDisabled() {
            return this.statusTiny.enable === 0;
        },
    },
    methods: {
        ...mapActions({
            getDetailStatusTn: `${moduleName}/getDetailStatusTn`,
            getDetailStatus: `${moduleName}/getDetailStatus`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            getListAktivitas: `${moduleName}/getListAktivitas`,
            toggleStatus: `${moduleName}/toggleStatus`,
            resetPage: `${moduleName}/resetPage`,
            resetList: `${moduleName}/resetList`,
        }),
        back() {
            this.$router.go(-1);
        },
        async init() {
            if (!this.getQuery.idStatus) {
                await this.back();
            } else {
                await this.resetPage({ target: "aktivitas" });
                await this.resetList({ target: "aktivitas" });
                await this.getDetailStatusTn(this.getQuery);
                await this.getDetailTinyDevice({ deviceId: this.getQuery.iddevice });
                await this.getListAktivitas(this.getQuery);
            }
        },
        setFormready(val) {
            this.formReady = val;
        },
        toogleOnOff(isChecked) {
            if (!this.isFetching) {
                this.toggleStatus({
                    iddevice: this.getQuery.iddevice,
                    idschedule: this.getQuery.idStatus,
                    enable: isChecked ? 1 : 0,
                });
            }
        },
        gotoEdit() {
            if (this.dataDeviceTiny.status !== 1) {
                this.$toast.warning("Perangkat tidak terhubung!");
                return;
            }
            this.getDetailStatus(this.getQuery);
            this.$router.push({ name: "wa_status.edit_status" });
        },
    },
};
</script>

<style scoped>
.detail-status {
    background-color: #ffffff;
    padding: 16px 20px;
}
.detail-status .containt {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 4px;
}

.detail-status .containt .left {
    height: 100px;
    width: 100px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 8px;
    border-color: #ededed;
}
.left img {
    width: 100%;
    height: auto;
}
.detail-status .containt .right {
    width: 100%;
    padding: 12px;
}
</style>
